<template>
	<form @submit.prevent="submitFixTx">
		<base-input label="ประเภท">
			<el-select v-model="fixType">
				<el-option label="ธนาคารไม่รัน" value="depositMemberBank" />
				<el-option label="ทรูมันนี่วอลเล็ทไม่รัน" value="depositMemberTruewallet" />
				<el-option label="เติมเครดิต" value="addCredit" />
				<el-option label="ตัดเครดิต" value="subCredit" />
			</el-select>
		</base-input>
		<base-input
			label="เบอร์โทรศัพท์ลูกค้า"
			placeholder="เบอร์โทรศัพท์ลูกค้า"
			v-model="phone"
			required
		/>
		<base-input label="จำนวน" placeholder="จำนวน" v-model.number="amount" maxlength="6" required />
		<base-input label="หมายเหตุ" placeholder="หมายเหตุ" v-model="remark" />

		<base-input
			label="วัน/เดือน/ปี เวลาที่โอนเงิน"
			placeholder="00/00/0000 00:00"
			v-model="transferTime"
			v-mask="'##/##/#### ##:##'"
			required
			v-if="showTransferTimeField"
		/>
		<base-input
			label="เทิร์น (เท่า)"
			placeholder="เทิร์น (เท่า)"
			v-model.number="turn"
			required
			v-if="showTurnField"
		/>
		<base-input
			label="ถอนสูงสุด (เท่า)"
			placeholder="ถอนสูงสุด (เท่า)"
			v-model.number="maxWithdraw"
			required
			v-if="showMaxWithdrawField"
		/>

		<base-button nativeType="submit" :disabled="loading">
			ยืนยัน
		</base-button>
	</form>
</template>

<script>
import { Select, Option } from 'element-ui'

import TxService from '../../services/tx.service'

export default {
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
		return {
			loading: false,

			fixType: 'depositMemberBank',
			phone: '',
			amount: 0,
			remark: '',
			transferTime: '',
			turn: 0,
			maxWithdraw: 0,
		}
	},
	computed: {
		showTransferTimeField() {
			return this.fixType === 'depositMemberBank' || this.fixType == 'depositMemberTruewallet'
		},
		showTurnField() {
			return this.fixType === 'addCredit'
		},
		showMaxWithdrawField() {
			return this.fixType === 'addCredit'
		},
	},
	methods: {
		submitFixTx() {
			this.loading = true
			TxService.fixTx({
				fixType: this.fixType,
				phone: this.phone,
				amount: this.amount,
				remark: this.remark,
				transferTime: this.transferTime,
				turn: this.turn,
				maxWithdraw: this.maxWithdraw,
			})
				.then(({ message }) => {
					this.$notify({
						type: 'success',
						message: message,
					})
				})
				.catch(({ message }) => {
					this.$notify({
						type: 'danger',
						message: message,
					})
				})
				.finally(() => {
					this.loading = false
				})
		},
	},
	created() {
		this.phone = this.$route.query.phone ?? ''
	},
}
</script>
